<template>
  <div class="grid">
    <div class="common-title" id="CORE-TECHNOLOGIES">
      <div class="common-title-content">
        核心技术
      </div>
    </div>
    <div class="technologies-card">
      <div
        class="technologies-card-item"
        v-for="(item, index) in items"
        :key="index"
      >
        <div class="card-top">
          <div class="ico" :class="item.icon"></div>
          <div class="text">{{ item.text }}</div>
        </div>
        <div class="card-info">
          <div class="text">{{ item.intro }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "coreTechnologies",
  data() {
    return {
      items: [
        {
          icon: "ico_aiot",
          text: "AIOT",
          intro:
            "围绕场景的公共安全、公共治理和公共服务等方面的应用需求，将AI与IoT深度结合，对场景的多维度数据进行全面精准化的采集，并且能够对人员、环境、物品的实时监测、智能分析、预测预警，实现安防管控、场景治理、服务水平的提升。"
        },
        {
          icon: "ico_omputing",
          text: "边缘计算",
          intro:
            "基于企业AIoT泛在接入能力，结合微场景精细化业务需求，用强大算力打通最后一公里，提升响应速度和处理能力，深化数据共享的范围和深度。 "
        },
        {
          icon: "ico_data",
          text: "大数据",
          intro:
            "自主研发的数据中台产品，能够支撑海量数据的汇聚、运算、分析、加工。通过数据模型、算法服务等标准化流程，形成数据资产，沉淀社会治理业务模型，为政府提供高效的数据服务，降低治理成本。"
        }
      ]
    };
  }
};
</script>

<style lang="less" scoped>
.grid {
  background-color: #f2f3f5;
  padding: 0 0 6.45rem;
  overflow: hidden;
  .technologies-card {
    display: flex;
    justify-content: center;
    overflow: hidden;
    .technologies-card-item {
      position: relative;
      flex: 0 0 26.9rem;
      height: 34.07rem;
      margin: 0 0.6rem;
      overflow: hidden;
      background-color: #ffffff;

      .card-top {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 19.35rem;
        margin-top: 7.5rem;
        transition: all 0.6s ease;
        .ico {
          width: 8.8rem;
          height: 10.79rem;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          &.ico_aiot {
            height: 10.89rem;
            background-image: url("~@/assets/images/coreCompetence/ico_aiot.png");
          }
          &.ico_omputing {
            background-image: url("~@/assets/images/coreCompetence/ico_omputing.png");
          }
          &.ico_data {
            background-image: url("~@/assets/images/coreCompetence/ico_data.png");
          }
        }
        .text {
          margin-top: 2.4rem;
          font-size: 0.9rem;
          font-weight: 600;
          color: #2a2e2e;
          line-height: 1.25rem;
        }
      }
      .card-info {
        position: absolute;
        bottom: -14.7rem;
        left: 0;
        width: 100%;
        height: 14.7rem;
        background: linear-gradient(#2098e0 0%, #2f62af 100%);
        transition: all 0.6s ease;
        .text {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 85%;
          font-size: 0.8rem;
          font-weight: 400;
          color: #ffffff;
          line-height: 1.4rem;
          transform: translate(-50%, -50%);
          text-align: justify;
        }
      }
      &:hover {
        .card-top {
          margin-top: 0;
        }
        .card-info {
          bottom: 0;
        }
      }
    }
  }
}
</style>
